import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cx } from 'class-variance-authority';
import { ReactNode } from 'react';

interface EmptyStateProps {
    icon?: IconDefinition;
    title: string;
    description?: ReactNode;
    action?: ReactNode;
    size?: 'default' | 'sm';
    className?: string;
}

// Displays an empty state with optional icon, description, and action CTA
export default function EmptyState({ icon, title, description, action, size = 'default', className }: EmptyStateProps) {
    const sm = size === 'sm';
    return (
        <div
            className={cx(
                'tw-flex tw-flex-col tw-items-center tw-text-center',
                sm ? 'tw-px-4 tw-py-6' : 'tw-px-6 tw-py-16',
                className
            )}
        >
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className={cx('tw-text-accents-4', sm ? 'tw-mb-2 tw-text-2xl' : 'tw-mb-4 tw-text-5xl')}
                />
            )}
            <span
                className={cx(
                    'tw-block tw-text-accents-9',
                    sm ? 'tw-mb-1 tw-text-sm tw-font-semibold' : 'tw-mb-2 tw-text-xl tw-font-bold'
                )}
            >
                {title}
            </span>
            {description && (
                <p className={cx('tw-max-w-md tw-text-accents-6', sm ? 'tw-mb-4 tw-text-xs' : 'tw-mb-6')}>
                    {description}
                </p>
            )}
            {action}
        </div>
    );
}
